import { ColDef, ValueFormatterParams } from '@ag-grid-community/core';
import ServerSideGridGroupHeader from 'components/ServerSideGridGroupHeader';
import i18n from 'i18n';
import { dateFilterParams } from '../../../shared/constants/index';
import AuditStatusCellRenderer from './AuditStatusCellRenderer';
import auditValueGetter from './auditValueGetter';
import stateValueFormatter from './stateValueFormatter';

/**
 * This value must be set in common-grid columnDefsVersion property. So, updating this value
 * forces common-grid to use the in code columnDefs instead of the saved grid setting.
 */
export const auditTrailsColumnDefVersion = '1';

const auditTrailsColumnDef: ColDef[] = [
  {
    headerName: i18n.t('audit.userAudit.grid.username'),
    field: 'userName',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    filterParams: {
      buttons: ['clear', 'apply'],
    },
    resizable: true,
    cellRenderer: 'agGroupCellRenderer',
    headerComponent: ServerSideGridGroupHeader as any,
    filterValueGetter: (params: Partial<ValueFormatterParams>): string => {
      return params.data?.userName;
    },
  },
  {
    headerName: i18n.t('audit.userAudit.grid.logipAddress'),
    field: 'clientIPAddress',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    filterParams: {
      buttons: ['clear', 'apply'],
    },
    resizable: true,
  },
  {
    headerName: i18n.t('audit.userAudit.grid.service'),
    field: 'serviceId',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    filterParams: {
      buttons: ['clear', 'apply'],
    },
    resizable: true,
    valueFormatter: stateValueFormatter,
  },
  {
    headerName: i18n.t('audit.userAudit.grid.action'),
    field: 'actionType',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    filterParams: {
      buttons: ['clear', 'apply'],
    },
    resizable: true,
  },
  {
    headerName: i18n.t('audit.userAudit.grid.name'),
    field: 'recordName',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    filterParams: {
      buttons: ['clear', 'apply'],
    },
    resizable: true,
  },
  {
    headerName: i18n.t('audit.userAudit.grid.result'),
    field: 'status',
    sortable: true,
    filter: 'agSetColumnFilter',
    floatingFilter: true,
    filterParams: {
      values: ['Success', 'Failed']
    },
    resizable: true,
    flex: 1,
    minWidth: 140,
    tooltipField: 'status',
    cellRenderer: AuditStatusCellRenderer as any,
    valueGetter: auditValueGetter,
  },
  {
    headerName: i18n.t('audit.userAudit.grid.time'),
    field: 'dateTimeEntry',
    sortable: true,
    filter: 'agDateColumnFilter',
    floatingFilter: true,
    resizable: true,
    filterParams: {
      dateFilterParams,
      buttons: ['clear', 'apply'],
    },
    cellRenderer: 'datetimeCellRenderer',
  },
];

export default auditTrailsColumnDef;
